import type { UIStringsOverride } from "../i18n-ui.ts";

/** Bengali (bn) UI strings. */
export const bn: UIStringsOverride = {
  actions: {
    addToCursor: "Cursor-এ যোগ করুন",
    addToVscode: "VS Code-এ যোগ করুন",
    askAI: "এই পৃষ্ঠা সম্পর্কে AI-কে জিজ্ঞাসা করুন",
    connectMcp: "MCP-তে সংযোগ করুন",
    copied: "অনুলিপি করা হয়েছে!",
    copyClaudeCode: "Claude Code কমান্ড অনুলিপি করুন",
    copyCode: "কোড অনুলিপি করুন",
    copyCodex: "Codex কমান্ড অনুলিপি করুন",
    copyMarkdown: "Markdown হিসেবে অনুলিপি করুন",
    copyServerUrl: "সার্ভার URL অনুলিপি করুন",
    edit: "GitHub-এ সম্পাদনা করুন",
    export: "এক্সপোর্ট করুন",
    exportEpub: "EPUB-এ এক্সপোর্ট করুন",
    exportPdf: "PDF-এ এক্সপোর্ট করুন",
    generating: "তৈরি হচ্ছে…",
    openIn: "{name}-এ খুলুন",
    openInChat: "চ্যাটে খুলুন",
    scrollToTop: "উপরে যান",
  },
  ask: {
    ai: "AI",
    clear: "কথোপকথন মুছুন",
    close: "বন্ধ করুন",
    copy: "কথোপকথন অনুলিপি করুন",
    empty: "ডকুমেন্টেশন সম্পর্কে একটি প্রশ্ন করুন।",
    error: "দুঃখিত, কিছু একটা ভুল হয়েছে।",
    label: "একটি প্রশ্ন করুন",
    placeholder: "একটি প্রশ্ন করুন…",
    send: "পাঠান",
    tip: "টিপ: চ্যাট খুলতে ও বন্ধ করতে চাপুন",
    title: "AI-কে জিজ্ঞাসা করুন",
    you: "আপনি",
  },
  banner: { dismiss: "ঘোষণা বন্ধ করুন" },
  changelog: {
    description: "পণ্য আপডেট এবং রিলিজ নোট।",
    showReleases: "{version} রিলিজ দেখান",
    title: "পরিবর্তন লগ",
  },
  content: { diagramError: "এই ডায়াগ্রামটি রেন্ডার করা যায়নি।" },
  feedback: {
    no: "না",
    question: "এই পৃষ্ঠাটি কি সহায়ক ছিল?",
    thanks: "আপনার মতামতের জন্য ধন্যবাদ!",
    yes: "হ্যাঁ",
  },
  languageSwitcher: { label: "ভাষা", untranslated: "অনূদিত নয়" },
  nav: {
    back: "ফিরে যান",
    breadcrumb: "ব্রেডক্রাম্ব",
    closeNavigation: "নেভিগেশন বন্ধ করুন",
    deprecated: "অপ্রচলিত",
    featured: "ফিচার্ড",
    githubRepository: "GitHub রিপোজিটরি",
    navigation: "নেভিগেশন",
    primary: "প্রধান",
    sections: "বিভাগসমূহ",
    toggleNavigation: "নেভিগেশন টগল করুন",
    toggleTheme: "রঙের থিম টগল করুন",
  },
  notFound: {
    description: "আপনি যে পৃষ্ঠাটি খুঁজছেন তা আমরা খুঁজে পাইনি।",
    home: "হোমে ফিরে যান",
    title: "পৃষ্ঠা পাওয়া যায়নি",
  },
  page: {
    lastUpdated: "সর্বশেষ আপডেট",
    next: "পরবর্তী",
    pagination: "পেজিনেশন",
    previous: "পূর্ববর্তী",
    skipToContent: "বিষয়বস্তুতে যান",
  },
  search: {
    all: "সব",
    allLanguages: "সব ভাষা",
    askAi: "AI-কে জিজ্ঞাসা করুন",
    askAiHint: "AI থেকে তাৎক্ষণিক উত্তর পান",
    button: "অনুসন্ধান",
    devOnly: "অনুসন্ধান প্রোডাকশন বিল্ডে উপলব্ধ।",
    error: "কিছু একটা ভুল হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।",
    label: "ডকুমেন্টেশন অনুসন্ধান করুন",
    navigate: "নেভিগেট",
    noResults: "কোনো ফলাফল পাওয়া যায়নি।",
    open: "খুলুন",
    placeholder: "ডকুমেন্টেশন অনুসন্ধান করুন…",
    popular: "জনপ্রিয়",
    preview: "প্রিভিউ",
    results: "ফলাফল",
  },
  toc: { title: "এই পৃষ্ঠায়" },
};
